import { useEffect, useState } from "react"
import { messageAndErrorStore, userStore } from "../store/Store"
import { useNavigate } from "react-router-dom"

export default function useGetFetch(url, setState) {
  // global
  const JwtToken = userStore(data => data.JwtToken)
  const setAuthError = messageAndErrorStore(data => data.setAuthError)
  const setAuthStatus = userStore(data => data.setAuthStatus)
  //local
  const [theData, setTheData] = useState(null)
  const [isPending, setIsPending] = useState(true)
  const [error, setError] = useState(null)
  const [statusCode, setStatusCode] = useState(200)
  const navigate = useNavigate()
  
  
  useEffect(() => {
    if (JwtToken === "") {
      navigate('/login')
      return
    }
    
    const controller = new AbortController()
    setIsPending(true)
    const headers = new Headers()
    headers.append("Content-Type", "application/json")
    headers.append("Authorization", "Bearer " + JwtToken)
    const ro = {
      method: "GET",
      headers,
      signal: controller.signal
    }
    fetch(url, ro)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            navigate('/login')
            setAuthError(false)
            setAuthStatus(false)
            return
          } else {
            setStatusCode(response.status)
            setError("Something went wrong")
          }
        }
        
        return response.json()
      })
      .then(data => {
        setTheData(data)
        if (setState) {
          setState(data)
        }
        setIsPending(false)
      })
      .catch(err => {
        if (err.name === "AbortError") {
          console.log("The fetch was aborted")
          setIsPending(false)
          return
        } else {
          setIsPending(false)
          setError("Could not load the Data")
        }
      })
      .finally(() => setIsPending(false))
      return (() => {
        controller.abort()
      })
  }, [JwtToken, navigate, url, setState, setAuthError, setAuthStatus])
  
  
  
  return {theData, isPending, error, statusCode }
}
